export default __webpack_public_path__ + "static/media/myglamm.68a5ea0e.png";